import { IModel, IAttribute, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Owned } from '../base/named';
import { GlobalVariables } from '../../constants/globals';
import { defaultTimeout, timeoutValidationPatterns } from './activity.const';
import { TimespanValidator } from '../base/validators';

/*
 * Activity Policy.
 */
@Metamodel.model({
    name: 'policy',
    display: [shellStringResources.ModelName_Policy, shellStringResources.ModelName_Policies],
    referable: true
})
export class ActivityPolicy extends Owned {
    public static readonly MODEL: IModel;
    public static readonly TIMEOUT: IAttribute;
    public static readonly RETRY: IAttribute;

    @Metamodel.attribute({
        association: 'TIMEOUT',
        display: shellStringResources.Timeout,
        constraint: {
            // max timeout 7 days (7.00:00:00) or any 0-6 days combination with time
            patterns: GlobalVariables.activityRunTimeLimit ? timeoutValidationPatterns : undefined,
            pattern: GlobalVariables.activityRunTimeLimit ? undefined : new RegExp('^(\\d+\\.)?((0?\\d)|(1\\d)|(2[0-3]))(:[0-5]?\\d){2}$'),
            validator: (activity: ActivityPolicy): IViolation[] | undefined => {
                if (activity.timeout && activity.timeoutDirty) {
                    try {
                        const timeoutInSeconds = TimespanValidator.toSeconds(activity.timeout);
                        if (timeoutInSeconds < 600) {
                            return [{ message: () => shellStringResources.Validator_MinTimeout}];
                        }
                    } catch {
                        return undefined;
                    }
                }
                return undefined;
            }
        }
    })
    public timeout?: string = defaultTimeout;

    @Metamodel.attribute({
        association: 'RETRY',
        display: shellStringResources.Retry,
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public retry?: number = 0;

    @Metamodel.attribute({
        constraint: {
            whole: true,
            minimum: 30,
            maximum: 86400
        }
    })
    public retryIntervalInSeconds?: number = 30;

    @Metamodel.attribute({
        constraint: {
            whole: true,
            minimum: 30,
            maximum: 86400,
            validator: (policy: ActivityPolicy): IViolation[] | undefined => {
                if (policy.exponentialRetry === true) {
                    const minValue = policy.retryIntervalInSeconds ?? 30;
                    const maxValue = policy.maxRetryIntervalInSeconds;
                    if (maxValue !== undefined && maxValue <= minValue) {
                        return [{ 
                            message: () => shellStringResources.ExponentialRetryValidationError || 'Maximum retry interval must be greater than the minimum retry interval when using exponential retry'
                        }];
                    }
                }
                return undefined;
            }
        }
    })
    public maxRetryIntervalInSeconds?: number;

    @Metamodel.attribute({})
    public exponentialRetry?: boolean;

    @Metamodel.attribute({
        display: shellStringResources.SecureOutput
    })
    public secureOutput?: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.SecureInput
    })
    public secureInput?: boolean = false;

    @Metamodel.attribute({})
    public retryConditions?: { type?: 'Expression'; value?: string };

    public timeoutDirty?: boolean = false;
}
